export const ANALYZE_PRODUCTS_LIST_VIEW = 'ANALYZE_PRODUCTS_LIST_VIEW';
export const ANALYZE_PRODUCT_DETAILS_VIEW = 'ANALYZE_PRODUCT_DETAILS_VIEW';
export const ANALYZE_PRODUCT_ADD_TO_CART = 'ANALYZE_PRODUCT_ADD_TO_CART';
export const ANALYZE_PRODUCTS_ADD_TO_CART = 'ANALYZE_PRODUCTS_ADD_TO_CART';
export const ANALYZE_PRODUCT_CLICK = 'ANALYZE_PRODUCT_CLICK';
export const ANALYZE_PRODUCT_WISHLIST_ADD = 'ANALYZE_PRODUCT_WISHLIST_ADD';
